import React from 'react'
import moment from 'moment'
// import { useOutletContext } from 'react-router-dom'
import EditJobDetailsModal from '../editJobDetailsModal'
import EditIcon from '@mui/icons-material/Edit';
import UseJobDetails from '../Hooks/useJobDetails';
import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add'

const AgentJobDetails = () => {
    const { data, methods, } = UseJobDetails()
    const { agentId } = useParams()

    const { jobDetailsList, user, splitLocation } = data
    const { getJobDetails, setJobDetailsModal } = methods
    const Edit_Permission = user?.userInfo?.permission?.team?.edit?.value

    // const calculateDuration = (totalDays) => {
    //     const duration = moment.duration(totalDays, 'days');
    //     const years = duration.years();
    //     const months = duration.months();
    //     const days = duration.days();
      
    //     return `${years} years, ${months} months, and ${days} days`;
    //   };
    const calculateDuration = (totalDays) => {
        const duration = moment.duration(totalDays, 'days');
        const years = duration.years();
        const months = duration.months();
        const days = duration.days();
      
        // Build the result string conditionally
        const parts = [];
        if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
        if (days > 0 || parts.length === 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
      
        return parts.join(', ');
      };
const {designation,dateOfJoining,employmentStatus,roleData,employmentStatusDate}=jobDetailsList?.data?.[0]|| {};

    return (
        <>
            <div className='row px-5'>
                {
                    (Edit_Permission && splitLocation[1] === 'team-management') &&
                    <div className="col-12 d-flex justify-content-end mt-3">
                        <Button className="dropDownButtons11" onClick={() => setJobDetailsModal((prev) => ({ ...prev, open: true, type: 'NEW' }))}>
                            Change Employement
                        </Button>
                        <hr />
                    </div>
                }
                <div className='col-12 border  rounded mt-4 py-3 shadow-sm ' style={{ minHeight: '135px' }}>
                    <div className='row'>
                        <div className="col-lg-6 mt-3">
                            <p>
                                <span className="fw-bold">Current Designation :</span> <span className="text-muted">{designation || "--"}</span>
                            </p>
                            <p>
                                <span className="fw-bold">Date Of Joining :</span>
                                <span className="text-muted ms-1">{moment(dateOfJoining).format('DD-MM-YYYY')}
                                </span>
                            </p>
                            <p>
                                <span className="fw-bold">Working :</span>
                                <span className="text-muted ms-1">{calculateDuration(jobDetailsList?.otherInfo)}
                                </span>
                            </p>
                            {
                                employmentStatus !== "ACTIVE" && employmentStatus &&
                                <p>
                                    <span className="fw-bold"> {employmentStatus === 'ONHOLD' ? 'Hold' : 'Relieving'} Date  :</span>
                                    <span className="text-muted ms-1">{moment(employmentStatusDate).format('DD-MM-YYYY')}
                                    </span>
                                </p>
                            }

                        </div>
                        <div className="col-lg-6 mt-3">
                            <p>
                                <span className="fw-bold">Employment Status :</span>
                                <span className="text-muted ms-1">{employmentStatus || '--'}</span>
                            </p>
                            <p>
                                <span className="fw-bold">Role :</span> <span className="text-muted">{roleData?.roleTitle || "--"}</span>
                            </p>
                        </div>
                    </div>
                </div>


                {/* <hr className='my-4'/> */}
                {
                    jobDetailsList?.data?.map((item, index) =>
                        <>
                            {
                                (Edit_Permission && splitLocation[1] === 'team-management') &&
                                <div className="col-12 d-flex justify-content-end mt-3">
                                    <EditIcon className='fs-4  pointer' color="primary" onClick={() => { getJobDetails('', item) }} />
                                </div>
                            }
                            <div className="col-lg-6 mt-3">
                                <p>
                                    <span className="fw-bold">Designation :</span> <span className="text-muted">{item?.designation || "--"}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Date Of Joining :</span>
                                    <span className="text-muted ms-1">{moment(item?.dateOfJoining).format('DD-MM-YYYY')}
                                    </span>
                                </p>
                                <p>
                                    <span className="fw-bold">Employee Type :</span>
                                    <span className="text-muted ms-1">{item?.employeeType === 'PERMANENT' ? 'Permanent' : item?.employeeType === 'CONTRACTUAL' ? 'Contractual' : 'Trainee'}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Probation Days :</span>
                                    <span className="text-muted ms-1">{item?.probationDays}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Employment Status :</span>
                                    <span className="text-muted ms-1">{item?.employmentStatus || '--'}</span>
                                </p>
                            </div>
                            <div className="col-lg-6 mt-3">
                                <p>
                                    <span className="fw-bold">Role :</span> <span className="text-muted">{item?.roleData?.roleTitle || "--"}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Shift :</span> <span className="text-muted">{item?.shiftData?.name || "--"}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Reporting Manager :</span>
                                    <span className="text-muted ms-1">{item?.reportingManagerName || '--'}</span>
                                </p>
                                <p>
                                    <span className="fw-bold">Earn Leave Calculate :</span>
                                    <span className="text-muted ms-1">{item?.isStartElCalculate ? 'Started' : 'Not Started' || '--'}</span>
                                </p>
                                <p className='d-flex'>
                                    <span className="fw-bold">Remark :</span>
                                    <span className="text-muted ms-1 text-break mt-1" dangerouslySetInnerHTML={{ __html: item?.employmentStatusRemarks }}></span>

                                </p>
                            </div>
                            {index !== jobDetailsList?.data?.length - 1 && <hr />}
                        </>
                    )
                }

                <EditJobDetailsModal data={data} methods={methods} id={agentId} />
            </div>
        </>
    )
}

export default AgentJobDetails
